import React from "react";
import CommonTooltip from "./CommonTooltip";

// Hover hint for toolbar buttons and icons. A thin wrapper over the shared blue CommonTooltip so
// every screen's hover hint looks and positions the same (flips sides and stays inside the window).
// `className` / `wrapperClassName` style the trigger wrapper; `langMode` is accepted for older
// call sites, CommonTooltip reads the language itself.
const HoverTooltip = ({
  text,
  children,
  position = "top",
  className = "",
  wrapperClassName = "",
  disabled = false,
}) => (
  <CommonTooltip
    text={disabled ? "" : text}
    position={position}
    disableDefaultDescription
    className={`${className} ${wrapperClassName}`.trim()}
    tooltipClassName="w-max max-w-[min(12rem,calc(100vw-1.5rem))] [text-wrap:balance]"
    fitContent
    clampToViewport
    hoverOnly
  >
    {children}
  </CommonTooltip>
);

export default HoverTooltip;
